import { render, staticRenderFns } from "./TheSpaceLFS.vue?vue&type=template&id=343fdd60&"
import script from "./TheSpaceLFS.vue?vue&type=script&lang=js&"
export * from "./TheSpaceLFS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports